module.exports = __webpack_public_path__ + "static/img/triangle-up.c06f1f19.svg";